import * as React from "react";
import { LibraryCard } from "../../../../types/LibraryCard";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Notes from "../../../Notes/Notes";
import MobileBookHeader from "./MobileBookHeader/MobileBookHeader";
import CardHistory from "../../../CardHistory/CardHistory";
import UserList from "../../../BookPage/UserList/UserList";
import ReviewCard from "../../BookCard/ReviewCard/ReviewCard";

interface Props {
	onClose: () => void;
	card: LibraryCard;
}

const MobileBookCard: React.FC<Props> = (props) => {
	return (
		<>
			<div className="book-calendar-dialogCard-toolbar">
				<IconButton onClick={props.onClose}>
					<CloseIcon />
				</IconButton>

				<div className="book-calendar-dialogCard-toolbar__header">
					{props.card.book.name}
				</div>
			</div>

			<div className="mobile-book-card__content">
				<div>
					<MobileBookHeader card={props.card} />
				</div>

				<UserList book={props.card.book} initialLabel="Также у: " />

				<div className="mobile-book-card__item">
					<CardHistory card={props.card} />
				</div>

				<div className="mobile-book-card__item">
					<ReviewCard card={props.card} />
				</div>

				<div>
					<Notes cardId={props.card.eId} />
				</div>
			</div>
		</>
	);
};

export default MobileBookCard;
